import { TrendGPTFollowUpAction, TrendGPTFollowUpDay, TrendGPTFollowUpHour, TrendGPTFollowUpRequest } from 'lib-trend-core';

export type WorkingHour = TrendGPTFollowUpHour;

// dayWeek: 1 = Monday … 7 = Sunday, the numbering of DAYS_OF_WEEK
export type WorkingDay = TrendGPTFollowUpDay;

export type FollowUpAction = TrendGPTFollowUpAction;

// The follow-up GPT Maker currently holds for the agent.
export type FollowUpConfig = Partial<TrendGPTFollowUpRequest>;

export interface TimeOption {
  label: string;
  value: number; // em segundos
}

export const TIME_OPTIONS: TimeOption[] = [
  { label: 'agents.timeOptions.min2', value: 120 },
  { label: 'agents.timeOptions.min5', value: 300 },
  { label: 'agents.timeOptions.min10', value: 600 },
  { label: 'agents.timeOptions.min15', value: 900 },
  { label: 'agents.timeOptions.min30', value: 1800 },
  { label: 'agents.timeOptions.h1', value: 3600 },
  { label: 'agents.timeOptions.h2', value: 7200 },
  { label: 'agents.timeOptions.h4', value: 14400 },
  { label: 'agents.timeOptions.h8', value: 28800 },
  { label: 'agents.timeOptions.d1', value: 86400 },
  { label: 'agents.timeOptions.d2', value: 172800 },
  { label: 'agents.timeOptions.d3', value: 259200 },
  { label: 'agents.timeOptions.d4', value: 345600 },
  { label: 'agents.timeOptions.d5', value: 432000 },
  { label: 'agents.timeOptions.d6', value: 518400 },
  { label: 'agents.timeOptions.d7', value: 604800 }
];

export const DAYS_OF_WEEK = [
  { value: 1, label: 'agents.followUp.dayMonday' },
  { value: 2, label: 'agents.followUp.dayTuesday' },
  { value: 3, label: 'agents.followUp.dayWednesday' },
  { value: 4, label: 'agents.followUp.dayThursday' },
  { value: 5, label: 'agents.followUp.dayFriday' },
  { value: 6, label: 'agents.followUp.daySaturday' },
  { value: 7, label: 'agents.followUp.daySunday' }
];
